import React from "react";
import { StyleSheet, View } from "react-native";
import { Headline, useTheme } from "react-native-paper";
import { ThemeType } from "../../theme/theme";
import { Text } from "../text/text";

interface FormTitleProps {
  text?: string;
  tx?: string;
}
export const FormTitle = ({ text, tx }: FormTitleProps) => {
  const theme = useTheme() as ThemeType;
  const styles = StyleSheet.create({
    container: {
      flex: 1,
      backgroundColor: theme.colors.lightGrey,
      paddingHorizontal: theme.spacing.medium,
      paddingVertical: theme.spacing.tiny,
    },
    textStyle: {
      fontSize: theme.fontSize.medium,
      textTransform: "uppercase",
      fontWeight: "600",
    },
  });
  return (
    <View style={styles.container}>
      <Text tx={tx} style={styles.textStyle}>
        {text}
      </Text>
    </View>
  );
};
